export type Roles = "teacher" | "student" | "admin";

export const Roles: Roles[] = ["teacher", "student", "admin"];
